module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/447.8a0c9d1d.png";